import React from "react";
import {Badge, Button, Col, Form, Modal} from "react-bootstrap";
import "tippy.js/dist/tippy.css";
import { useTranslation } from 'react-i18next';

const WithdrawalDetails = ({part, setPart}) => {

    const { t } = useTranslation();

    const handleCloseModal = () => {
        setPart();
    };


    return (
        <div>
            {part ?
                <Modal show={part} onHide={handleCloseModal} size="md">
                    <Modal.Header closeButton>
                        <Modal.Title><Badge className={"outline-secondary font-max mr-1"}>{t("common.part")}</Badge> <Badge size="sm" variant="primary">{part.id}</Badge></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form noValidate>
                            <Form.Row>
                                <Col>
                                    <Form.Group controlId="date_name_control">
                                        <Form.Label><strong>{part.withdrawalDate ? t("common.withdrawal_date") : t("forms.delivery_date")}</strong></Form.Label>
                                        <Form.Control
                                            name="date_name"
                                            value={part.withdrawalDate}
                                            disabled={true}
                                            type="text"
                                            placeholder=""
                                        />
                                    </Form.Group>
                                </Col>
                            </Form.Row>
                            <Form.Row>
                                <Col>
                                    <Form.Group controlId="user_name_control">
                                        <Form.Label><strong>{t("common.user_withdrawn")}</strong></Form.Label>
                                        <Form.Control
                                            name="user_name"
                                            value={part.withdrawalUser}
                                            disabled={true}
                                            type="text"
                                            placeholder=""
                                        />
                                    </Form.Group>
                                    {part.withdrawalUser ?
                                        <Form.Group>
                                            <Form.Label><strong>{t("common.comment")}</strong></Form.Label>
                                            <Form.Control as="textarea"
                                                          disabled={true}
                                                          name="comment"
                                                          value={part.withdrawalComment}
                                                          type="text"
                                            />
                                        </Form.Group>
                                        : ""
                                    }
                                </Col>
                            </Form.Row>

                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" className="Modal_btn_submit"
                                onClick={handleCloseModal}>{t("common.continue")}</Button>
                    </Modal.Footer>
                </Modal> : ""}
        </div>
    );
};


export default WithdrawalDetails;